import { React } from 'react'
import { Typography, Grid, Box } from '@material-ui/core';
import ErrorLogCard, { ErrorLogCardSkeleton } from './ErrorLogCard';
import useErrorLog from './../../hooks/useErrorLog';


const ErrorLog = ({ error_log }) => {

    const { erro_log, isLoading } = useErrorLog();
   
    return (
        <div>
            <Grid container justify="space-between">
                <Grid item>
                    <Typography variant="h6" color="textSecondary" gutterBottom>
                        LISTE D'ERREUR
                    </Typography>
                </Grid>
            </Grid>
            <Box style={{ height: 20 }} />
            <Grid container spacing={4} >
                {isLoading ?
                    <ErrorLogCardSkeleton />
                    : erro_log && erro_log.map((error_log, idx) => (
                        <Grid key={idx} item xs sm={8} md={5}>
                            <ErrorLogCard
                            style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}
                            error_log = {error_log}
                            />
                        </Grid>
                    ))}
            </Grid>
        </div>
    )
}

export default ErrorLog